var exports = {
  "S": "hiddenIcon__DNzFUz",
};

module.exports = exports;
